<template>
    <div>
        <div v-for="category in categorizedOptions" :key="category.id">
            <h4 class="mb-3 mt-2">{{ category.name }}</h4>
            <ul class="accessory-list">
                <li v-for="option in category.options" v-bind:key="option.id">
                    {{ option.name }} (<currency
                        :value="option.price"
                    ></currency
                    >)
                </li>
            </ul>
        </div>
        <i v-if="categorizedOptions.length == 0">{{ emptyText }}</i>
    </div>
</template>

<style lang="scss" scoped>
.accessory-list {
    font-size: 1.3rem;
}

h4 {
    font-weight: bold;
}
</style>

<script>
import CatalogModelOptionMixin from "../mixins/CatalogModelOption";

export default {
    props: {
        categorizedOptions: {
            type: Array,
            required: true,
        },
        emptyText: {
            type: String,
            required: false,
            default: "Nessun accessorio selezionato.",
        },
    },

    data: function () {
        return {};
    },
};
</script>
